import React from 'react';
import {
  loSearchColumns,
  QUERY_KEYS,
  vatTuSearchColumns,
  viTriSearchColumns,
  warehouseSearchColumns
} from '@/constants';
import { KhoHang, Lo, VatTu, ViTri } from '@/types/schemas';
import { SearchField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface DetailTabProps {
  formMode: FormMode;
}

const DetailTab = ({ formMode }: DetailTabProps) => {
  return (
    <div className='p-4'>
      {/* Mã vật tư */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Mã vật tư</Label>
        <SearchField<VatTu>
          type='text'
          name='ma_vt'
          searchEndpoint={`/${QUERY_KEYS.VAT_TU}/`}
          searchColumns={vatTuSearchColumns}
          columnDisplay='ma_vt'
          displayRelatedField='ten_vt'
          dialogTitle='Danh mục vật tư'
          className='w-100'
        />
      </div>

      {/* Mã kho */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Mã kho</Label>
        <SearchField<KhoHang>
          type='text'
          name='ma_kho'
          searchEndpoint={`/${QUERY_KEYS.KHO_HANG}/`}
          searchColumns={warehouseSearchColumns}
          columnDisplay='ma_kho'
          displayRelatedField='ten_kho'
          dialogTitle='Danh mục kho hàng'
          className='w-100'
        />
      </div>

      {/* Mã lô */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Mã Lô</Label>
        <SearchField<Lo>
          type='text'
          name='ma_lo'
          searchEndpoint={`/${QUERY_KEYS.LO}/`}
          searchColumns={loSearchColumns}
          columnDisplay='ma_lo'
          displayRelatedField='ten_lo'
          dialogTitle='Danh mục lô'
          className='w-100'
        />
      </div>

      {/* Mã vị trí */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Mã vị trí</Label>
        <SearchField<ViTri>
          type='text'
          name='ma_vi_tri'
          searchEndpoint={`/${QUERY_KEYS.VI_TRI}/`}
          searchColumns={viTriSearchColumns}
          columnDisplay='ma_vi_tri'
          displayRelatedField='ten_vi_tri'
          dialogTitle='Danh mục vị trí kho hàng'
          className='w-100'
        />
      </div>
    </div>
  );
};

export default DetailTab;
